<div class="row">
  <div class="col-sm-12">
    <p [innerHTML]="content" class="wrapper"></p>
  </div>
</div>
